import { addNotification, ActionKeys } from "./actions";
export default function (toaster) {
    const actions = {
        addNotification
    };
    const selectors = {};
    const showToastsEpic = (action$) => action$
        .ofType(ActionKeys.ADD_NOTIFICATION)
        .do(action => {
        toaster.show(action.payload);
    })
        .filter(() => false);
    const middleware = [showToastsEpic];
    return { actions, reducer: undefined, middleware, selectors };
}
//# sourceMappingURL=index.js.map